import { useEffect, useState } from "react";

const useResponsiveSize = () => {
  const [size, setSize] = useState("regular");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width >= 2500) setSize("large");       // xl-high
      else if (width >= 1600) setSize("regular"); // xl-mid
      else if (width >= 1280) setSize("regular");   // xl-low
      else setSize("regular");                      // below xl-low
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size?.toString() || "regular"; // Ensure a string is returned
};

export default useResponsiveSize;
